import 'css-chunksrc/client/scenes/assignToTask/projectSelection/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_1ycah_1",
  "checked": "_checked_1ycah_12"
};